import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useContractSearchDispatch, useContractSearchState } from './contract-search-context';
import { useBaseData } from '../../../../application/context/base-data-context';

export const useContractSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useContractSearchDispatch();
    const state = useContractSearchState();
    const baseData = useBaseData();

    useEffect(() => {
        if (baseData.loaded) {
            dispatch({ type: ACTION_TYPES.setTypeContract, payload: baseData.typeContract });
            dispatch({ type: ACTION_TYPES.setCategoryProcess, payload: baseData.categoryProcess });
        }
    }, [baseData.loaded]);

    function handleOnChange(e: any) {
        let term = state.parameters.term;
        let categoryProcessId = state.parameters.categoryProcessId;
        let contractTypeId = state.parameters.contractTypeId;
        let clientId = state.parameters.clientId;
        let year = state.parameters.year;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }
        if (e.target.name === "select-category-process") {
            categoryProcessId = e.target.value;
        }
        if (e.target.name === "select-contract-type") {
            contractTypeId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }
        if (e.target.name === "input-year") {
            const parsed = parseInt(e.target.value, 10);
            year = isNaN(parsed) ? undefined : parsed;
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                term,
                clientId,
                categoryProcessId,
                contractTypeId,
                year
            }
        });
    }

    function handleSearch() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                page: 0
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0,
                pageSize: 100,
                term: undefined,
                clientId: undefined,
                categoryProcessId: undefined,
                contractTypeId: undefined,
                year: undefined
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/contratos/publicar');
    }

    return {
        handleOnChange,
        handleSearch,
        handleClearFilters,
        navigateToCreate
    };
}
